import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { SvgDataUriInput } from "@/shared/components/images/svg-data-uri-input";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import {
  updateMasterDataPdfCache,
  usePatchMasterDataPdfMutation,
  useShowMasterDataPdfQuery,
} from "@/services/backend/company/api/master-data-pdf";
import {
  MasterDataPdfDefault,
  MasterDataPdfHeaderData,
} from "@/services/backend/company/types/master-data-pdf";

export function MasterDataPdfHeaderDataCard({ id }: { id: string }) {
  const { data, error, isLoading } = useShowMasterDataPdfQuery({ id });

  return (
    <div>
      {data && <Content data={data} />}
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
    </div>
  );
}

function Content({ data }: { data: MasterDataPdfDefault }) {
  const [set, { error }] = useOptimisticDebouncedMutation(
    { id: data.id },
    updateMasterDataPdfCache,
    usePatchMasterDataPdfMutation(),
  );

  const setHeaderData = (headerData: MasterDataPdfHeaderData) =>
    set({ id: data.id, headerData }, { ...data, headerData });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Briefkopf")}</CardTitle>
        <CardDescription>
          {t("Claim und Logo im Kopf des Dokuments. Nur SVG.")}
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6 sm:grid-cols-2">
        <SvgDataUriInput
          label={t("Claim")}
          value={data.headerData.claim}
          onValueChange={(claim) =>
            setHeaderData({ ...data.headerData, claim })
          }
          errors={inputValidationErrorMessages(error, "headerData.claim")}
        />
        <SvgDataUriInput
          label={t("Logo")}
          value={data.headerData.logo}
          onValueChange={(logo) => setHeaderData({ ...data.headerData, logo })}
          errors={inputValidationErrorMessages(error, "headerData.logo")}
        />
      </CardContent>
    </Card>
  );
}
